import type { FunctionComponent } from "react";

import { Link } from "react-router-dom";
import { Button } from "../../ui/button";
import type { IPayoutTransactionMinimal } from "../../../types/models/payout-transaction.modals.types";

type AppProps = {
	payout: IPayoutTransactionMinimal;
	className?: string;
};
export const RejectButton: FunctionComponent<AppProps> = ({
	payout,
	className,
}) => {
	if (!payout) {
		return null; // or handle the error appropriately
	}
	return (
		<Link to={`/admin/payouts/${payout.id}/reject`} className={className}>
			<Button
				className={`bg-rejectbuttonbg border border-rejectbuttonborder font-semibold text-rejectbuttontext tracking-wider ${className}`}
			>
				Reject
			</Button>
		</Link>
	);
};
